import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICoreServiceInitialState, ICoreService } from "./CoreServicesModel";
import {
  ActiveInactiveCoreService,
  createCoreService,
  deleteCoreService,
  getAllActiveCoreService,
  getAllCoreServices,
  getCoreServiceByID,
  CoreServiceImageUpload,
  updateCoreService,
} from "./services/coreServices.services";

const initialState: ICoreServiceInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  CoreServiceID: null,
  CoreServiceList: [],
  CoreServiceDetail: {
    ServicesID: null,
    CoreService: "",
    LongDescription: "",
    SortDescription: "",
    IsActive: 1,
  },
};

const coreserviceSlice = createSlice({
  name: "coreservice",
  initialState,
  reducers: {
    clearCoreServiceDetail: (state) => {
      state.CoreServiceDetail = initialState.CoreServiceDetail;
    },
    setCoreServiceID: (state, action) => {
      state.CoreServiceID = action.payload;
    },
    clearCoreServiceID: (state) => {
      state.CoreServiceID = initialState.CoreServiceID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllCoreServices.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCoreServices.fulfilled,
      (state, action: PayloadAction<ICoreService[]>) => {
        state.loading = false;
        state.CoreServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllCoreServices.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CoreServiceList = [];
    });
    builder.addCase(createCoreService.pending, (state) => {
      state.loading = false;
      state.error = "";
    });
    builder.addCase(createCoreService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createCoreService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCoreService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCoreService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCoreService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCoreService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCoreService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCoreService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getCoreServiceByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getCoreServiceByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CoreServiceDetail = action.payload;
    });
    builder.addCase(getCoreServiceByID.rejected, (state, action) => {
      state.loading = false;
      state.CoreServiceDetail = initialState.CoreServiceDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveCoreService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCoreService.fulfilled,
      (state, action: PayloadAction<ICoreService[]>) => {
        state.loading = false;
        state.CoreServiceList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCoreService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CoreServiceList = [];
    });
    builder.addCase(ActiveInactiveCoreService.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveCoreService.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveCoreService.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(CoreServiceImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(CoreServiceImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CoreServiceImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCoreServiceDetail, clearCoreServiceID, setCoreServiceID } =
  coreserviceSlice.actions;
export default coreserviceSlice.reducer;
